import { translations } from "../Translation/staticTranslation"
import { getAppLanguage } from "../getAppLanguage"

export const getBusinessColumns = (status) => {
  const lang = getAppLanguage()
  const merchantPage = translations[lang]?.MerchantsPage?.tableCol

  if (status === "approved") {
    return [
      {
        label: merchantPage?.Merchant_name,
        dataKey: lang === "ar" ? "name_arabic" : "name_english",
        sortable: true,
        sortKey: "name_english",
      },
      {
        label: merchantPage?.Vendor_name,
        dataKey: lang === "ar" ? "vendor_name_arabic" : "vendor_name",
        sortable: true,
        sortKey: "vendor_name",
        serverSortable: false,
        // Badges rows whose request came from an approved sales request. The
        // approved tab is served by /api/business/, which carries no origin
        // flag yet, so nothing renders there until that link exists.
        salesRequestBadge: true,
      }, // Nested key
      {
        label: merchantPage?.store_name,
        dataKey: lang === "ar" ? "store_name_display_ar" : "store_name_display_en",
        sortable: true,
        sortKey: "store_names",
        serverSortable: true,
      },
      {
        label: merchantPage?.ecom_platform,
        dataKey: "e_commerce_plateform",
        sortable: true,
        serverSortable: false,
      },
      {
        label: merchantPage?.industry,
        dataKey: "industry",
        sortable: true,
        serverSortable: false,
      },
      { label: merchantPage?.country, dataKey: "country", sortable: true },
      { label: merchantPage?.joined_at, dataKey: "joined_at" },
      { label: merchantPage?.no_of_store, dataKey: "store_count", sortable: true },
      {
        label: merchantPage?.product_count,
        dataKey: "product_count",
        sortable: true,
      },
      { label: merchantPage?.status, dataKey: "active_status" },
    ]
  } else if (status === "pending") {
    return [
      {
        label: merchantPage?.Merchant_name,
        dataKey: lang === "ar" ? "business_name_arabic" : "business_name",
        sortable: true,
        sortKey: "business_name",
      },
      {
        label: merchantPage?.Vendor_name,
        dataKey: lang === "ar" ? "vendor_name_arabic" : "vendor_name",
        sortable: true,
        sortKey: "vendor_name",
        serverSortable: false,
        // Badges rows whose request came from an approved sales request. The
        // approved tab is served by /api/business/, which carries no origin
        // flag yet, so nothing renders there until that link exists.
        salesRequestBadge: true,
      },
      {
        label: merchantPage?.ecom_platform,
        dataKey: "e_commerce_plateform",
        sortable: true,
        serverSortable: false,
      },
      {
        label: merchantPage?.industry,
        dataKey: "industry",
        sortable: true,
        serverSortable: false,
      },
      {
        label: (
          <>
            <span className={`${lang === "ar" ? "ml-10" : "mr-10"}`}>
              {merchantPage?.status}
            </span>
            {/* <Tooltip title={merchantPage?.merchant_pending_tooltip}>
              <InfoCircleOutlined />
            </Tooltip> */}
          </>
        ),
        dataKey: "request_status",
      },
    ]
  } else {
    return [
      {
        label: merchantPage?.Merchant_name,
        dataKey: lang === "ar" ? "business_name_arabic" : "business_name",
        sortable: true,
        sortKey: "business_name",
      },
      {
        label: merchantPage?.Vendor_name,
        dataKey: lang === "ar" ? "vendor_name_arabic" : "vendor_name",
        sortable: true,
        sortKey: "vendor_name",
        serverSortable: false,
        // Badges rows whose request came from an approved sales request. The
        // approved tab is served by /api/business/, which carries no origin
        // flag yet, so nothing renders there until that link exists.
        salesRequestBadge: true,
      },
      {
        label: merchantPage?.ecom_platform,
        dataKey: "e_commerce_plateform",
        sortable: true,
        serverSortable: false,
      },
      {
        label: merchantPage?.industry,
        dataKey: "industry",
        sortable: true,
        serverSortable: false,
      },
      {
        label: <>{merchantPage?.status} </>,
        dataKey: "request_status",
      },
    ]
  }
}
